/* eslint-disable -- TODO: fix eslint errors */

import './index.scss';
import {
  COMPANY_NAME,
  HELP_URL,
  MARKETING_LINKS,
  SOCIAL_LINKS,
} from '../../constants/brand';
import fb from '../../assets/images/icons/facebook.svg';
import insta from '../../assets/images/icons/instagram.svg';
import linkedin from '../../assets/images/icons/linkedin.svg';
import pinterest from '../../assets/images/icons/pinterest.svg';
import tiktok from '../../assets/images/icons/tiktok.svg';
import Button from '../v2/Button/Button';
import { Typography } from '../v2/Typography/Typography';

const Footer = () => {
  return (
    <div
    >
      <div className='flex md:flex-row flex-col justify-center md:justify-between items-center removeElevioOnMobile mt-12 gap-4'>
        <div
        >
          <Button
            className='mr-4'
            variant='text'
            onClick={() => {
              window.open(MARKETING_LINKS.privacyPolicy, '_blank');
            }}
          >
            Privacy policy
          </Button>
          <Button
            className='mr-4'
            variant='text'
            onClick={() => {
              window.open(MARKETING_LINKS.termsOfService, '_blank');
            }}
          >
            TOS
          </Button>
          <Button
            className='mr-4'
            variant='text'
            onClick={() => {
              window.open(HELP_URL, '_blank');
            }}
          >
            Help Center
          </Button>
          <Button
            className='mr-4'
            variant='text'
            onClick={() => {
              window.Beacon('navigate', '/ask/');
              window.Beacon('open');
            }}
          >
            Contact Us
          </Button>
        </div>

        <div
        >
          <div className='flex flex-row'>
            <a href={SOCIAL_LINKS.linkedin} target={'_blank'}>
              <img src={linkedin} alt={'linkedin'} className={'mr-5'} />
            </a>
            <a href={SOCIAL_LINKS.tiktok} target={'_blank'}>
              <img src={tiktok} alt={'insta'} className={'mr-5'} />
            </a>
            <a href={SOCIAL_LINKS.pinterest} target={'_blank'}>
              <img src={pinterest} alt={'insta'} className={'mr-5'} />
            </a>
            <a href={SOCIAL_LINKS.facebook} target={'_blank'}>
              <img src={fb} alt={'fb'} className={'mr-5'} />
            </a>
            <a href={SOCIAL_LINKS.instagram} target={'_blank'}>
              <img src={insta} alt={'insta'} className={'mr-5'} />
            </a>
          </div>
        </div>
        <div>
          <Typography
            variant='functional-low'
            type='body-200'
            className='text-forest-300'
          >
            <>All Rights Reserved © {new Date().getFullYear()} {COMPANY_NAME}</>
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Footer;
